const bcrypt = require('bcryptjs');
const isaac = require('./isaac');
let fallbackSet = false;
let _fallback;

// eslint-disable-next-line no-undef
const _p = { isReactNative: typeof __SST_REACT_NATIVE__ !== 'undefined' && __SST_REACT_NATIVE__ };
 

module.exports = {
    encrypt,
    compare,
    compareSync,
    setRandomFallback,
    getRandomFallback,
    getSalt,
    _p
};

//Async
function encrypt(value) {
    if (_p.isReactNative && !fallbackSet) setDefaultRandomFallback();
    return bcrypt.hash(value, 10);
}

//Async
function compare(plainTextValue, hash) {
    if (_p.isReactNative && !fallbackSet) setDefaultRandomFallback();
    return bcrypt.compare(plainTextValue, hash);
}

//Synchronous
function compareSync(plainTextValue, hash) {
    if (_p.isReactNative && !fallbackSet) setDefaultRandomFallback();
    return bcrypt.compareSync(plainTextValue, hash);
}

function setDefaultRandomFallback() {
    isaac.seed(new Date().toString());
    setRandomFallback(length => Math.floor(isaac.random() * Math.pow(10, length - 1)));
}

/**
 * React native does not implement webcrypto so bcryptjs chokes.
 * This method allows a fallback crypto hash generator to be specified.
 * If no fallback is provided, a pseudorandom generator will be used, but the entropy
 * for it will only be *ok*.
 * @param {Function} fallback same as bcrypt.setRandomFallback
 */
function setRandomFallback(fallback) {
    _fallback = fallback;
    bcrypt.setRandomFallback(fallback);
    fallbackSet = true;
}

function getRandomFallback() {
    return _fallback;
}

//Async
function getSalt(rounds) {
    return bcrypt.genSalt(rounds);
}
